/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 480:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Module dependencies
 */
var _require = __webpack_require__(506),
  Aphrodite = _require.StyleSheet;

/**
 * Enables support for nested rule "&"" to reference selector of the parent rule.
 */
var _Aphrodite$extend = Aphrodite.extend([{
    selectorHandler: function selectorHandler(selector, baseSelector, generateSubtreeStyles) {
      var nestedTags = [];
      if (selector[0] === '&') {
        var selectors = selector.split(',');
        for (var i = 0; i < selectors.length; i += 1) {
          var space = selector[1] === ' ' ? ' ' : '';
          var tag = i === 0 ? selectors[i].slice(1) : selectors[i];
          nestedTags.push(generateSubtreeStyles("".concat(baseSelector).concat(space).concat(tag).replace(/ +(?= )/g, '')));
        }
      }
      return nestedTags.length > 0 ? nestedTags : null;
    }
  }]),
  StyleSheet = _Aphrodite$extend.StyleSheet,
  css = _Aphrodite$extend.css;

/**
 * Expose Aphrodite functions
 */
module.exports = {
  StyleSheet: StyleSheet,
  css: css
};

/***/ }),

/***/ 506:
/***/ ((module) => {

"use strict";
module.exports = require("aphrodite/no-important");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(480);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=aphrodite.js.map